let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bm2JI")).then(() => parcelRequire('93vxT'));